/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

// domain/navigation/navigation.mapper.js

export function mapNavigation(categories, items) {

    const sortedCategories = [...categories]
        .filter(c => c.active !== false)
        .sort((a, b) => a.sort_order - b.sort_order)

    return sortedCategories
        .map(category => {

            const categoryKey =
                category.entity_key ??
                category.key ??
                category.id

            const children = items
                .filter(item =>
                    item.category_key === categoryKey &&
                    item.active !== false &&
                    item.visible !== false
                )
                .sort((a, b) => a.sort_order - b.sort_order)
                .map(item => ({
                    key: item.entity_key,

                    path: item.route,

                    title: item.label,
                    subtitle: item.description ?? null,

                    breadcrumb: [
                        category.label,
                        item.label
                    ],

                    icon: null,
                    badgeKey: null,
                    meta: item.meta ?? {}
                }))

            return {
                key: categoryKey,
                title: category.label,
                icon: null,
                children
            }
        })
        .filter(section => section.children.length > 0)
}